import { NavLink } from "react-router-dom";
export default NavLink;
